module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/7-bg-6bcca493d83af6ce48510adfea7576ba.png";